<template>
  <div>
    <!-- <banner :obj="obj"></banner> -->
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="w80 mb-30">
      <el-container>
        <el-aside width="330px">
          <sidebar></sidebar>
        </el-aside>
        <el-main>
          <companySide v-if="type"
           :isButton="isButton"
            @release="gorelease()"
            @withdrawal="goRawal()"
            @companyUpgrade ="onCompanyUpgrade()"></companySide>
          <headSide v-else :isShow="isShow" @onWithdrawal="goRawal()" @release ="gorelease()"></headSide>
          <div class="mt-30">
            <div>
              <contTitle :obj="obj" :contTitle="contTitle1"></contTitle>
              <el-tabs v-model="activeName" style="margin-top:15px;" type="border-card">
                <el-tab-pane v-for="item in tabMapOptions" :key="item.key" :label="item.label" :name="item.key">
                  <keep-alive>
                     <tab-pane v-if="activeName==item.key" :pubstat ="item.key" />
                  </keep-alive>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div style="margin-top: 50px">
              <contTitle :obj="obj" :contTitle="contTitle2"></contTitle>
              <div class="table">
                <el-table
                  :data="tableData2"
                  v-loading="loading"
                  :header-cell-style="headClass"
                  stripe
                  fit
                  style="width: 100%; font-size: 12px"
                >
                  <el-table-column
                    align="center"
                    prop="userName"
                    label="提现用户"
                  >
                <template slot-scope="scope">
                    <span>{{JSON.parse(scope.row.cashoutinfo).name }}</span>
                </template>
                  </el-table-column>			  
                  <el-table-column
                    align="center"
                    prop="amount"
                    label="提现金额（￥）"
                  >
                  </el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="transDate"
                    label="提现时间"
                  >
                  </el-table-column>
                     <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="status"
                    label="提现状态"
                  >
                  <template slot-scope="scope">
                  <span v-if="scope.row.status =='3'">待提现</span>
                  <span class="gren" v-if="scope.row.status =='4'">提现成功</span>
                  <span class="err" v-if="scope.row.status =='5'">提现失败</span>
                  </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="receiveTypeStr"
                    label="收款账户类型"
                  >
                <template slot-scope="scope">
                    <span  v-if="JSON.parse(scope.row.cashoutinfo).alipayNumbe">{{JSON.parse(scope.row.cashoutinfo).alipayNumbe !=''?'支付宝':''}}</span>
                    <span  v-if="JSON.parse(scope.row.cashoutinfo).weChatNumber" >{{JSON.parse(scope.row.cashoutinfo).weChatNumber !=''?'微信':''}}</span>
                    <span  v-if="JSON.parse(scope.row.cashoutinfo).accountNumber">{{JSON.parse(scope.row.cashoutinfo).accountNumber !=''?'银行卡':''}}</span>
                </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="receiveAccount"
                    label="收款账户"
                  >
                  <template slot-scope="scope">
                   <span v-if="JSON.parse(scope.row.cashoutinfo).alipayNumbe">{{JSON.parse(scope.row.cashoutinfo).alipayNumbe !=''?JSON.parse(scope.row.cashoutinfo).alipayNumbe:''}}</span>
                   <span v-if="JSON.parse(scope.row.cashoutinfo).weChatNumber">{{JSON.parse(scope.row.cashoutinfo).weChatNumber !=''?JSON.parse(scope.row.cashoutinfo).weChatNumber:''}}</span>
                   <span v-if="JSON.parse(scope.row.cashoutinfo).accountNumber">{{JSON.parse(scope.row.cashoutinfo).accountNumber !=''?JSON.parse(scope.row.cashoutinfo).accountNumber:''}}</span>
                  </template>
                  </el-table-column>
                </el-table>
                <Pagination
                  v-show="totals > 0"
                  :total="totals"
                  :page.sync="listQuery.curPage"
                  :limit.sync="listQuery.limit"
                  @pageChange="pageChange"
                ></Pagination>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script>
import {incomeList,cashoutlist} from "@/api/coment";
import sidebar from "../../common/sidebar";
import headSide from "../../common/headSide";
import companySide from "../../common/companySide";
import commBanner from "../../common/commBanner";
import titleHead from "../../common/titleHead";
import contTitle from "../../common/contTitle";
import Pagination from "../../components/Pagination";
import tabPane  from '../../components/TabPane'
export default {
  name:'Tab',
  components: {
    sidebar,
    headSide,
    companySide,
    commBanner,
    titleHead,
    contTitle,
    Pagination,
    tabPane
  },
  data() {
    return {
      obj: {
        title: "我的收入",
        isShow: false,
        roleType:'',
        personalType:9,
        companytype:'',
      },
      isShow: true,
      contTitle1: "收支明细",
      contTitle2: "提现明细",
      headTitle: "我的收入",
      tableData: [],
      tableData2: [],
      listQuery: {
        curPage: 1,
        limit: 5,
      },
      total: 0, //总条数
      totals:0,
      listLoading: true,
      loading:true,
      isButton:true,
      type:false,
      activeName:'0',
      tabMapOptions:[
        { label: '全部', key: '0' },
        { label: '资料', key: '1' },
        { label: '课程/课件', key: '4' }, 
        { label: '问题', key: '5' },
        { label: '产品', key: '6' },
        { label: '平台', key: '1000' },
        { label: '充值', key: '1001' },
        { label: '收入', key: '2' },
        { label: '支出', key: '3' }
      ]
    };
  },
  created() {
    this.getIncomeList();
    this.getCashoutlist();
    let type = this.$store.state.user.userInfo.type;
    this.obj.roleType = type;
    if(type == 3){
      this.type = true;
      this.headTitle = '企业收入';
      this.obj.title = '企业收入';
    }
    // const tab = this.$route.query.tab
    // if (tab) {
    //   this.activeName = tab
    // }
  },
  watch:{
    activeName(val) {
      this.$router.push(`${this.$route.path}?tab=${val}`)
    }
  },
  methods: {
    //修改表头样式
    headClass() {
      return "background:#FF7402;text-align:center;color:white;";
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
      }
    },
    //提现
    goRawal() {
      this.$router.push("/withdrawal");
    },
    //发布
    gorelease(){
      this.$router.push('/demand')
    },
    getgoodstypename(goodstype){
      let rt="";
      switch(goodstype){
         case 1:
           rt="资料"
           break;
         case 4:
           rt="课件"
           break;
         case 5:
           rt="问题"
            break;
        case 6:
          rt="产品"
            break;
        case 1000:
           rt="平台"
           break;
        case 1001:
           rt="充值"
           break;
        default:
          break
      }
      return rt;
    },
    //收入
    getIncomeList() {
      this.listLoading = true;
      incomeList({
        ...this.listQuery,goodstypes:1,
        querytype:2
      })
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.page.list;
            this.total = res.page.totalCount;
          }
          this.listLoading = false;
        })
        .catch((err)=>{});
    },
    //提现明细
    getCashoutlist() {
      this.loading = true;
      cashoutlist(this.listQuery)
        .then((res) => {
          if (res.code == 0) {
            this.tableData2 = res.page.list;
            this.totals = res.page.totalCount;
          }
          this.loading = false;
        })
        .catch((err) => {});
    },
    //分页
    pageChange(item) {
      this.listQuery["curPage"] = item.page;
      this.listQuery["limit"] = item.limit;
	    this.getCashoutlist()
    },
	//收入明细分页
	Recepage(item){
	  this.listQuery["curPage"] = item.page;
	  this.listQuery["limit"] = item.limit;
	  this.getIncomeList();
	},
    //升级
    onCompanyUpgrade(){
      this.$router.push('/corporate_member')
    }
  },
};
</script>
<style scoped>
/deep/ .el-table__header {
  width: 100% !important;
}
/deep/ .el-table__body {
  width: 100% !important;
}
/deep/ .el-tooltip {
  width: 100% !important;
}
.cont_text {
  margin-left: 12px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.table {
  margin-top: 20px;
  /* height: 280px; */
}
.el-table .warning-row {
  background: oldlace;
}

/*  斑马纹表格背景 */
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fff8f2;
}

.gren{ 
 color: #56c451;
}
.err{
  color: #ef9c9a;
}
</style>



// WEBPACK FOOTER //
// src/view/coment/income.vue